import { render } from "./RoomsIcon.vue?vue&type=template&id=d27e4d1a&scoped=true"
import script from "./RoomsIcon.vue?vue&type=script&lang=js"
export * from "./RoomsIcon.vue?vue&type=script&lang=js"

import "./RoomsIcon.vue?vue&type=style&index=0&id=d27e4d1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27e4d1a"]])

export default __exports__